import React, { useEffect, useRef } from 'react'
interface AutoScrollToBottomProps {
  children: React.ReactNode
  className?: string
}

/**
 * A component that automatically scrolls to the bottom of its content.
 */
export const AutoScrollToBottom: React.FC<AutoScrollToBottomProps> = ({ children, className }) => {
  const divRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null
    let count = 0

    const scrollToBottom = () => {
      if (divRef.current) divRef.current.scrollTop = divRef.current.scrollHeight
    }

    scrollToBottom() // Initial scroll to bottom

    intervalId = setInterval(() => {
      if (count < 10) {
        scrollToBottom()
        count++
      } else if (intervalId) {
        clearInterval(intervalId)
      }
    }, 1)

    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [])

  return (
    <div ref={divRef} className={className}>
      {children}
    </div>
  )
}
